export default __webpack_public_path__ + "static/media/profileCard.762c8373.png";